import { Box, styled } from '@mui/material';
import color from 'src/theme/color';

export const Container = styled(Box)`
    background-color: ${color.blackRock};
    margin-top: 30px;
    border-radius: 4px;
`;

export const DescriptionText = styled('div')`
    color: ${color.white};
`;

export const MarkdownContainer = styled(Box)`
    padding: 10px;
    .wmde-markdown {
        background-color: transparent;
        font-size: 14px;
        color: ${color.white};

        a {
            text-decoration: underline;

            &:hover {
                text-decoration: none;
            }
        }

        pre {
            padding: 1em;
            border-radius: 4px;
            overflow-x: auto;
            color: ${color.black};
        }

        .attachment-item {
            display: inline-flex;
            align-items: center;
            gap: 8px;
            background-color: rgba(32, 34, 45, 1);
            border-radius: 15px;
            padding: 4px 16px;
            margin: 0 5px;
            max-width: 200px;
        }

        .attachment-icon {
            display: inline-block;
            width: 16px;
            height: 16px;
            background-size: contain;
            background-repeat: no-repeat;
        }

        .image-icon {
            background-color: ${color.lightBlue};
            mask: url('../assets/icons/image.svg') no-repeat center;
        }

        .video-icon {
            background-color: ${color.lightBlue};
            mask: url('../assets/icons/video.svg') no-repeat center;
        }

        .attachment-filename {
            color: ${color.yellow};
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            max-width: 150px;
        }
    }
`;

export const AttachmentsContainer = styled(Box)`
    margin-top: 2px;
    padding: 12px;
    border-radius: 4px;
    font-size: 12px;
`;
